import { render, staticRenderFns } from "./AccountDetails.vue?vue&type=template&id=23428745&scoped=true&"
import script from "./AccountDetails.vue?vue&type=script&lang=js&"
export * from "./AccountDetails.vue?vue&type=script&lang=js&"
import style0 from "./AccountDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AccountDetails.vue?vue&type=style&index=1&id=23428745&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23428745",
  null
  
)

export default component.exports